// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialogFullPage_usqkP {
    position: fixed !important;
    bottom: 0 !important
}

.dialog_mthm2 {
    
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/molten/lib/imagine/view/BulkCreateItem.css"],"names":[],"mappings":"AAAA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;;AAEA","sourcesContent":[".dialogFullPage {\n    position: fixed !important;\n    bottom: 0 !important\n}\n\n.dialog {\n    \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialogFullPage": `dialogFullPage_usqkP`,
	"dialog": `dialog_mthm2`
};
export default ___CSS_LOADER_EXPORT___;
